export class ValidationUtils {
  static alphanumericRegex = /^[a-zA-Z0-9]*$/;
}
